export default __webpack_public_path__ + "static/media/stroke4_filled-min.0259ebf7.png";